"use client";

import { useAuth0 } from "@auth0/auth0-react";

export default function LaunchButton({ isScrolled, isLarge }) {
  const { loginWithRedirect, isAuthenticated } = useAuth0();

  const handleClick = () => {
    if (!isAuthenticated) {
      loginWithRedirect({
        authorizationParams: {
          screen_hint: "signup",
        },
      });
    }
  };

  return (
    <button
      onClick={handleClick}
      className={`whitespace-nowrap rounded-lg border-2 border-[#d56f5e] bg-[var(--qk-ink)] font-lato font-bold text-[var(--qk-paper)] shadow-red-small transition-all duration-200 hover:border-[#c45e4d] hover:shadow-red-large ${
        isLarge
          ? "px-8 py-2.5 text-xl sm:px-8 sm:py-4 lg:px-8 lg:py-4 lg:text-2xl"
          : isScrolled
          ? "px-2 py-1.5 text-sm sm:px-4 sm:py-2 lg:px-5 lg:py-2 lg:text-base"
          : "px-3 py-2 text-base sm:px-5 sm:py-2 lg:px-7 lg:py-3 lg:text-lg"
      }`}
    >
      <span className="hidden lg:inline">Get started for free</span>
      <span className="lg:hidden">Get started</span>
    </button>
  );
}
